module.exports = __webpack_public_path__ + "8fd8e61d86ac5278785aea1d452ef91b.png";